import { render, staticRenderFns } from "./ImgSet.vue?vue&type=template&id=f90b34e8&scoped=true&"
import script from "./ImgSet.vue?vue&type=script&lang=js&"
export * from "./ImgSet.vue?vue&type=script&lang=js&"
import style0 from "./ImgSet.vue?vue&type=style&index=0&id=f90b34e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f90b34e8",
  null
  
)

/* custom blocks */
import block0 from "./ImgSet.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports